import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConfirm = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 152,
	height: 130,
	viewBox: "0 0 152 130",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 75.9998,
			cy: 64.8,
			rx: 55.2,
			ry: 55.2,
			fill: "#5C65A3"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11.9999,
			cy: 16,
			r: 5.6,
			fill: "#BA5E74"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 8.3998,
			cy: 112.4,
			rx: 7.6,
			ry: 7.6,
			fill: "#BA5E74"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 144.4,
			cy: 33.2,
			rx: 7.60001,
			ry: 7.6,
			fill: "#BA5E74"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 132.4,
			cy: 4.4,
			rx: 4.39999,
			ry: 4.4,
			fill: "#BA5E74"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M56.2158 84.8903L56.6221 85.0252L57.052 80.8217L59.0692 79.1704L61.2786 80.0218C60.6062 80.2984 59.9637 80.8302 59.5091 81.6238C59.1028 82.3104 58.7144 83.2789 58.2908 84.6825C57.5086 87.3097 46.5316 95.9701 51.0527 101.875C52.5361 103.8 55.4031 102.693 56.8666 101.163C58.066 99.9317 58.8623 98.8089 59.4061 97.7817C59.919 99.4304 60.8055 100.893 59.057 102.199L60.1593 105.112L49.4774 109.154C48.6029 106.843 47.721 104.512 46.8465 102.201C45.0771 91.4806 43.9108 80.0658 54.6395 72.0987C55.217 71.7471 59.7669 69.3372 60.9401 69.9146C62.4686 70.6684 61.1511 73.0541 59.1354 74.4163L58.8394 74.5727L56.8331 75.0209L53.7367 78.2796L52.7073 82.7765L53.0459 83.0258L54.0752 78.5289L57.1717 75.2703L57.9003 75.0834L61.328 75.3406C64.964 76.2073 65.1136 79.9473 60.7542 79.3987C60.6618 79.3893 60.5889 79.3725 60.4965 79.363L59.3044 78.9704L58.8981 78.8355L56.6457 80.6868L56.2158 84.8903Z",
			fill: "#E6C299"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M60.449 89.6828C60.9534 87.6713 62.9927 85.2567 63.9491 83.2075C64.1544 82.7524 64.2819 82.3267 64.3197 81.9571C65.053 81.7241 65.8829 81.2769 66.4981 82.1986C67.7332 83.9959 64.0762 85.0688 64.0762 85.0688L61.261 89.7752L60.408 93.9167C60.5004 92.2832 60.144 90.9305 60.449 89.6828Z",
			fill: "#E6C299"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M59.0621 79.1509L57.0449 80.8023L56.6223 85.0252L56.216 84.8903L56.6653 80.6795L58.9178 78.8281L59.3046 78.9704L59.0621 79.1509Z",
			fill: "#9C9ACB"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M54.0559 78.5363L53.0265 83.0332L52.688 82.7839L53.7368 78.2796L56.8332 75.0209L58.8395 74.5727L57.8736 75.0713L57.1718 75.2703L54.0559 78.5363Z",
			fill: "#9C9ACB"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M68.3619 52.3862C64.7684 45.3534 63.0336 39.771 64.3947 38.9674C66.1028 37.9658 72.0022 44.8144 77.5715 54.2523L76.7175 54.7531C75.2713 52.2808 72.1051 50.8367 68.3619 52.3862Z",
			fill: "#8D93BF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M68.362 52.3862C72.1051 50.8367 75.2714 52.2808 76.7369 54.7458L71.4017 57.8968C70.2611 55.9971 69.2469 54.1384 68.362 52.3862Z",
			fill: "#FBFCFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M71.3748 57.8847L76.71 54.7337C78.1561 57.2061 77.8942 60.6799 74.7347 63.1853C73.6314 61.5602 72.5081 59.765 71.3748 57.8847Z",
			fill: "#DEE0ED"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M74.7421 63.2047C77.9015 60.6993 78.1829 57.2181 76.7174 54.7531L77.5714 54.2524C83.1407 63.6903 86.2864 72.1803 84.5784 73.1818C83.2099 73.966 79.1508 69.7515 74.7421 63.2047Z",
			fill: "#263073"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M74.742 63.2047C79.1507 69.7514 83.2098 73.966 84.5709 73.1623L80.2886 75.6929C80.0918 75.7008 79.895 75.7087 79.6981 75.7165C79.2971 75.7129 79.022 75.5727 78.3864 75.1249C75.3954 72.9707 70.9321 66.8665 67.1118 60.4079L71.3941 57.8773C72.5079 59.7649 73.6312 61.5601 74.742 63.2047Z",
			fill: "#BA5E74"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M71.3747 57.8847L67.0924 60.4153C63.448 54.2454 60.3883 47.7433 59.7553 44.0752C59.55 42.8874 59.539 42.4475 59.887 41.783C59.9427 41.6953 60.0104 41.5809 60.066 41.4932L64.3871 38.9479C63.026 39.7516 64.7608 45.334 68.3543 52.3668C69.2467 54.1384 70.2608 55.9971 71.3747 57.8847Z",
			fill: "#BA5E74"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M59.7746 44.0679C60.4003 47.7166 63.4599 54.2187 67.1117 60.408L46.8941 72.3428L41.7401 63.5914C51.3775 57.2584 53.9107 51.7484 59.9137 41.7951C59.5389 42.4475 59.5693 42.8801 59.7746 44.0679Z",
			fill: "#FBFCFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M41.7401 63.5914L46.8941 72.3428L43.9536 74.0771L38.8289 65.4034C39.8819 64.783 40.8304 64.1799 41.7401 63.5914Z",
			fill: "#8D93BF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M38.8485 65.396L43.9731 74.0697L43.0682 74.6119L42.78 74.1437C42.548 73.7652 42.0178 73.655 41.5811 73.9091L36.6049 76.8354C36.1682 77.0895 35.9924 77.6223 36.2244 78.0007L36.5125 78.4689L35.6076 79.0112L30.4829 70.3375L38.8485 65.396ZM34.9341 74.004L39.9103 71.0777C40.3471 70.8236 40.5229 70.2908 40.2909 69.9124L39.7266 68.9492C39.4946 68.5707 38.9645 68.4605 38.5277 68.7145L33.5515 71.6409C33.1148 71.8949 32.939 72.4277 33.171 72.8062L33.7353 73.7694C33.9478 74.1552 34.5048 74.2775 34.9341 74.004Z",
			fill: "#BA5E74"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M39.7071 68.9565L40.2714 69.9197C40.5034 70.2982 40.3275 70.831 39.8908 71.085L34.9146 74.0114C34.4779 74.2655 33.9283 74.1626 33.7157 73.7768L33.1514 72.8135C32.9194 72.4351 33.0953 71.9023 33.532 71.6482L38.5082 68.7219C38.9449 68.4678 39.4945 68.5707 39.7071 68.9565Z",
			fill: "#5C65A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M36.5975 76.816L41.5737 73.8896C42.0104 73.6356 42.56 73.7385 42.7726 74.1243L43.0608 74.5925L36.4931 78.4763L36.2049 78.0081C35.985 77.6028 36.1608 77.0701 36.5975 76.816Z",
			fill: "#5C65A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M30.4562 70.3255L35.5809 78.9991L31.8955 81.1707L28.9424 76.1824C27.7576 74.1662 28.428 71.537 30.4562 70.3255Z",
			fill: "#5C65A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M51.8919 84.9055L61.6186 79.1604L62.0973 79.9562L64.8111 84.5466L65.1921 85.2017L67.9059 89.792C68.8513 91.4103 69.1106 92.7998 67.6135 94.4763C66.7705 95.417 63.653 97.3292 62.2368 97.5764C60.8474 97.8357 59.354 97.4683 58.5677 96.2117L51.8919 84.9055Z",
			fill: "#BA5E74"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M77.8579 74.7255C74.9588 72.4033 70.7564 66.5778 67.1119 60.4079L46.8944 72.3428L52.0484 81.0941C62.2501 75.7243 68.2814 76.1732 79.9218 75.7208C79.166 75.7181 78.8153 75.4956 77.8579 74.7255Z",
			fill: "#DEE0ED"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M52.0411 81.0747L46.8871 72.3234L43.9465 74.0577L49.0712 82.7313C50.1121 82.1377 51.1021 81.5855 52.0411 81.0747Z",
			fill: "#BA5E74"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M49.0786 82.7507L43.9539 74.077L43.049 74.6193L43.3372 75.0875C43.5692 75.466 43.3933 75.9987 42.9566 76.2528L37.9804 79.1792C37.5437 79.4332 36.9941 79.3303 36.7815 78.9445L36.4933 78.4763L35.5884 79.0185L40.7131 87.6922L49.0786 82.7507ZM39.6438 81.9911L44.62 79.0648C45.0567 78.8107 45.6063 78.9136 45.8189 79.2994L46.3832 80.2626C46.6152 80.6411 46.4394 81.1739 46.0026 81.4279L41.0264 84.3543C40.5897 84.6083 40.0401 84.5055 39.8275 84.1196L39.2633 83.1564C39.0313 82.778 39.2071 82.2452 39.6438 81.9911Z",
			fill: "#BA5E74"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M46.3832 80.2626L45.8189 79.2994C45.5869 78.921 45.0567 78.8107 44.62 79.0648L39.6438 81.9911C39.2071 82.2452 39.0313 82.778 39.2633 83.1564L39.8275 84.1197C40.0595 84.4981 40.5897 84.6084 41.0264 84.3543L46.0026 81.4279C46.4394 81.1739 46.6152 80.6411 46.3832 80.2626Z",
			fill: "#7C84B6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M37.9803 79.1792L42.9565 76.2528C43.3932 75.9988 43.569 75.466 43.337 75.0875L43.0489 74.6193L36.4932 78.4763L36.7814 78.9445C37.0134 79.323 37.5509 79.4527 37.9803 79.1792Z",
			fill: "#7C84B6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M40.7055 87.6728L35.5808 78.9991L31.8954 81.1707L34.8485 86.1589C36.0406 88.1945 38.6772 88.8843 40.7055 87.6728Z",
			fill: "#7C84B6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M51.8919 84.9055L49.071 82.7313C50.1046 82.1182 51.0946 81.566 52.041 81.0747C55.2272 79.4029 57.9825 78.2938 60.6538 77.5494L61.6065 79.1872L51.8919 84.9055Z",
			fill: "#BA5E74"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.8819 104.967L47.8525 110.276L51.7453 120.564L65.7746 115.255L61.8819 104.967Z",
			fill: "#9FA8DF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.7102 114.902L51.7456 120.564L55.2845 129.917L70.2491 124.254L66.7102 114.902Z",
			fill: "#BA5E74"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M59.5087 81.6238C59.9633 80.8302 60.6058 80.2985 61.2782 80.0218C61.5113 79.9336 61.7249 79.8528 61.9338 79.8182C63.2844 79.5736 64.5311 80.3452 64.3269 81.9766C64.2891 82.3462 64.1616 82.7719 63.9563 83.227C63.012 85.2494 60.9606 87.6908 60.4562 89.7023C60.1318 90.9573 60.4882 92.31 60.442 93.9483C60.4015 95.0737 60.1769 96.3576 59.401 97.8279C58.8572 98.8551 58.0536 99.9585 56.8615 101.209C55.3907 102.72 52.531 103.846 51.0476 101.921C46.5265 96.0163 57.5035 87.3559 58.2857 84.7287C58.714 83.2789 59.1219 82.3031 59.5087 81.6238ZM61.1512 83.0894L62.5942 83.6757C62.9406 83.3004 64.1159 82.1231 64.107 81.5714C64.1096 80.8155 62.221 79.9315 61.6299 80.5992C61.0194 81.2743 61.1197 82.302 61.1512 83.0894Z",
			fill: "#F5E7D6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M61.1509 83.0894C61.1268 82.3214 61.0192 81.2742 61.6297 80.5992C62.2402 79.9242 64.1094 80.8155 64.1067 81.5714C64.0962 82.1304 62.9404 83.3004 62.5939 83.6757L61.1509 83.0894Z",
			fill: "#F3F3F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77.7987 39.9482C77.7143 40.1989 77.4348 40.3484 77.154 40.2578C76.9 40.1788 76.7522 39.9066 76.849 39.6293L84.4904 17.4844C84.5748 17.2337 84.8543 17.0842 85.1351 17.1749C85.389 17.2538 85.5368 17.5261 85.4401 17.8033L77.7987 39.9482Z",
			fill: "#F3F3F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M83.1347 52.0063C82.9019 52.1591 82.5905 52.1044 82.4391 51.8813C82.2876 51.6582 82.3512 51.3537 82.5841 51.2009L119.245 26.6094C119.478 26.4566 119.789 26.5113 119.94 26.7344C120.092 26.9575 120.028 27.262 119.795 27.4148L83.1347 52.0063Z",
			fill: "#F3F3F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M88.9683 62.6048C88.6921 62.5978 88.4765 62.3895 88.4603 62.1057C88.4714 61.8339 88.6864 61.6188 88.9752 61.5987L114.599 61.5367C114.875 61.5436 115.091 61.7519 115.107 62.0357C115.096 62.3075 114.881 62.5227 114.592 62.5427L88.9683 62.6048Z",
			fill: "#F3F3F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.4364 45.1396C81.3266 45.2686 81.1265 45.2787 80.9893 45.1558C80.8594 45.052 80.8538 44.8575 80.9834 44.721L91.2159 34.0321C91.3257 33.9031 91.5258 33.893 91.663 34.0159C91.7929 34.1197 91.7985 34.3142 91.6688 34.4507L81.4364 45.1396Z",
			fill: "#F3F3F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.4676 55.7296C87.3047 55.7668 87.1904 55.9322 87.2358 56.1105C87.2812 56.2889 87.4426 56.4233 87.6054 56.3861L101.894 53.4724C102.057 53.4353 102.171 53.2698 102.126 53.0915C102.08 52.9131 101.919 52.7787 101.756 52.8159L87.4676 55.7296Z",
			fill: "#F3F3F7"
		})
	]
});
export default SvgConfirm;
